import { GET_REQUEST, POST_REQUEST } from '@helpers/request';
import { API_HOST_NAME } from '../env';
import { call } from 'redux-saga/effects';

const structurePaths = {
  getAgentInformationByAgentCode: `${API_HOST_NAME}/agent/get-agent-information-by-agent-code`,
  getOpmAssignmentList: `${API_HOST_NAME}/opm/get-opm-assignment-list`,
  getAgentsUnderAd: `${API_HOST_NAME}/opm/get-agents-under-ad`,
  getEligiblePolicies: `${API_HOST_NAME}/opm/get-eligible-policies`,
  getSuitableAgents: `${API_HOST_NAME}/opm/get-suitable-agents`,
  validateAgentForAssignment: `${API_HOST_NAME}/opm/validate-agent-for-assignment`,
  resumeStepFunction: `${API_HOST_NAME}/opm/resume-step-function`,
};

export const getAgentInformationByAgentCodeService = ({ agentCode }) => {
  return GET_REQUEST(structurePaths.getAgentInformationByAgentCode, {
    agentCode,
  });
};

export const getOpmAssignmentListService = (params) => {
  return GET_REQUEST(structurePaths.getOpmAssignmentList, params);
};

export function* getAllOpmAssignmentsService(params) {
  const pageSize = 100;
  const assignments = [];
  let page = 1;

  while (true) {
    const response = yield call(getOpmAssignmentListService, {
      ...params,
      page,
      pageSize,
    });
    const data = response?.data ?? response;
    const rows = data?.assignments ?? data;
    if (!Array.isArray(rows)) {
      throw new Error('Invalid OPM assignment list response');
    }
    assignments.push(...rows);

    const totalCount = data?.totalCount;
    if (
      rows.length === 0 ||
      (totalCount != null
        ? assignments.length >= totalCount
        : rows.length < pageSize)
    ) {
      break;
    }
    page += 1;
  }

  return {
    data: { assignments, totalCount: assignments.length },
  };
}

export const getAgentsUnderAdService = (params) => {
  return GET_REQUEST(structurePaths.getAgentsUnderAd, params);
};

export const getEligiblePoliciesService = (params) => {
  return GET_REQUEST(structurePaths.getEligiblePolicies, params);
};

export const getSuitableAgentsService = (policyNumbers) => {
  return POST_REQUEST(structurePaths.getSuitableAgents, null, {
    data: policyNumbers,
  });
};

export const validateAgentForAssignmentService = (payload) => {
  return POST_REQUEST(structurePaths.validateAgentForAssignment, payload);
};

export const resumeStepFunctionService = (payload) => {
  return POST_REQUEST(structurePaths.resumeStepFunction, payload);
};
